// import React, { useState, useContext, useEffect } from 'react';
// import {
//   TextField,
//   Button,
//   Typography,
//   Container,
//   Box,
//   Select,
//   MenuItem,
//   InputLabel,
//   FormControl,
//   Card,
//   CardContent,
//   InputAdornment,
// } from '@mui/material';
// import AccountCircleIcon from '@mui/icons-material/AccountCircle';
// import LockIcon from '@mui/icons-material/Lock';
// import TvIcon from '@mui/icons-material/Tv';
// import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
// import { motion } from 'framer-motion';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import JSEncrypt from 'jsencrypt';
// import { toast } from 'react-toastify';
// // import 'react-toastify/dist/ReactToastify.css';
// import { UserContext } from '../context/UserContext'; 
// import { AuthContext } from '../context/AuthContext';

// // import { setInMemoryNTID } from '../utils/apiClient'; // my new function for frontend
// import apiClient from '../utils/apiClient';
// //this is for only login of our app --> ntid and pass will be checked --> then they will again hit it to check in the data base for the ntid
// import apiClient2 from '../utils/apiClient2';


// function LoginPage() {
//   const [ntid, setNtid] = useState('');
//   const [password, setPassword] = useState('');
//   const [selectedChannel, setSelectedChannel] = useState('');
//   const [channelData, setChannelData] = useState([]);
//   const [error, setError] = useState('');
//   const [isLoading, setIsLoading] = useState(false);
//   const [showChannelSelection, setShowChannelSelection] = useState(false); 
//   const navigate = useNavigate();
//   const { setUserNTID, setUserChannel, userNTID } = useContext(UserContext);
//   const { setUser } = useContext(AuthContext);
//   const PUBLIC_KEY = 'MIGeMA0GCSqGSIb3DQEBAQUAA4GMADCBiAKBgH5ZLNKluDikQ+Bjp80aiTvCHo5axT76N5GRyeE/rdU1I/OQmha+EKmvNAHxa6aGft5XwPOciqMaEdWrhJ+rPhScbkZFZdApGJtn717SKHv/vVrcvUW9JkMzBLJ9Xl/B0WM5PXFlLeof89UVC52r+Zq05C/DFUVBNjLxvZmdkCOtAgMBAAE='
//   // Only fetch channels after the user is authenticated and showChannelSelection is true
//   useEffect(() => {
//     const fetchChannels = async () => {
//       if (showChannelSelection) {
//         try {
//           // const response = await axios.get('http://localhost:8000/liva/channels', { withCredentials: true });
//           const response = await apiClient.post('/channels', { withCredentials: true });
//           setChannelData(response.data.channels);
//         } catch (err) {
//           console.error('Error fetching channels:', err);
//           setChannelData([]);
//         }
//       }
//     };
//     fetchChannels();
//   }, [showChannelSelection]);
//   const mockResponse = {
//     data: {
//       Token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ989nidasjninf888888888knipn8ua888888",
//       data: "[{\"ntid\":\"9999\",\"timestamp\":\"12172024T123456Z\"}]"
//     }
//   };  
//   const encryptData = (data) => {
//     const encryptor = new JSEncrypt();
//     encryptor.setPublicKey(PUBLIC_KEY);
//     return encryptor.encrypt(data);
//   };
//   const handleLoginSubmit = async () => {
//     if (!ntid || !password) {
//       setError('Please enter NTID and Password');
//       return;
//     }
//     try {
//       // setIsLoading(true);
//       // const encryptedNTID = encryptData(ntid);
//       // const encryptedPassword = encryptData(password);
//       // const encryptedMetaData = encryptData(
//       //   JSON.stringify({
//       //     ntid: ntid,
//       //     timestamp: Date.now(),
//       //   })
//       // );
//       setIsLoading(true);
//       const encryptedNTID = (ntid);
//       const encryptedPassword = (password);
//       const encryptedMetaData = (
//         JSON.stringify({
//           ntid: ntid,
//           timestamp: Date.now(),
//         })
//       );
//       // Call the const.jwt endpoint
//       // const response = await axios.post('https://apignonprod.iciciprulife.com/v1/generate/ldap/encrypted/authentication', {
//       const response = await apiClient2.post('https://api-dex.iciciprulife.com/v1/generate/ldap/encrypted/jwt', {
//         ntID: encryptedNTID,
//         password: encryptedPassword,
//         channel:'',
//         encData: encryptedMetaData,
//       });

//       // // Use mockResponse instead of actual response
//       // const response = mockResponse;
//       // if (response.data.Token) {
//       //   toast.success("Authentication Successful!");
// //this is for apignonprod
//       // if (response.data.Status=="Login Successful") {
// //this is for apidex
//       if (response.data.message=="User found and token issued") {
//         // Extract NTID from response.data.data if available
//         let userInfo;
//         if (typeof response.data.data === 'string') {
//           try {
//             userInfo = JSON.parse(response.data.data);
//           } catch {
//             userInfo = { NTID: ntid };
//           }
//         } else {
//           userInfo = response.data.data || { NTID: ntid };
//         }
//         // Store NTID in userContext for frontend usage
//         setUserNTID(userInfo.NTID || ntid);
//         // 2) Also store it in memory for encryption usage
//         // setInMemoryNTID(ntid);  
//         // Now show the channel selection UI
//         setShowChannelSelection(true);
//       } else {
//         setError("Authentication Failed!");
//       }
//     } catch (error) {
//       console.error("Error:", error);
//       setError(
//         error.response?.data?.message || "Something went wrong. Please try again."
//       );
//     } finally {
//       setIsLoading(false);
//     }
//   };
//   const handleChannelConfirm = async () => {
//     if (!selectedChannel) {
//       setError('Please select a channel');
//       return;
//     }
//     try {
//       // userNTID is now available from the context at the component level
//       const response = await apiClient.post('/userindatabase', {
//         ntid: userNTID,
//         channel: selectedChannel
//       }, { withCredentials: true });
//       // If success, store channel in userContext
//       setUserChannel(selectedChannel);
//       // Set user in AuthContext to indicate we are logged in
//       setUser({ username: userNTID, channel: selectedChannel });
//       // Navigate to protected route
//       navigate('/dashboard/customer-segmentation');
//     } catch (err) {
//       console.error('Error in userindatabase call:', err);
//       setError('User not authorized. Please contact admin.');
//     }
//   };
//   return (
//     <Container maxWidth="sm">
//       <motion.div
//         initial={{ opacity: 0, y: -50 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ duration: 0.5 }}
//       >
//         <Card
//           sx={{
//             mt: 8,
//             p: 4,
//             borderRadius: '20px',
//             boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.2)',
//           }}
//         >
//           <CardContent>
//             <Box sx={{ textAlign: 'center', mb: 4 }}>
//               <Typography
//                 variant="h2"
//                 sx={{
//                   fontSize: '60px',
//                   fontWeight: '900',
//                   background: 'linear-gradient(to right, #1670e6 10%, #ef4123 30%, #1670e6 70%)',
//                   WebkitBackgroundClip: 'text',
//                   WebkitTextFillColor: 'transparent',
//                   backgroundSize: '200% auto',
//                   animation: 'shineEffect 3s linear infinite',
//                   letterSpacing: '5px',
//                   lineHeight: '1',
//                 }}
//               >
//                 LIVA
//               </Typography>
//               <style>
//                 {`
//                   @keyframes shineEffect {
//                     0% { background-position: 0% 50%; }
//                     50% { background-position: 100% 50%; }
//                     100% { background-position: 0% 50%; }
//                   }
//                   @keyframes typewriter {
//                     from { width: 0; }
//                     to { width: 100%; }
//                   }
//                   .typewriter {
//                     overflow: hidden;
//                     white-space: nowrap;
//                     border-right: 3px solid rgba(0, 0, 0, 0.75);
//                     animation: typewriter 3s steps(40) infinite alternate;
//                   }
//                 `}
//               </style>
//             </Box>
//             {!showChannelSelection && (
//               <>
//                 <Typography
//                   variant="h6"
//                   // className="typewriter"
//                   sx={{
//                     color: '#A52A2A',
//                     fontWeight: 'bold',
//                     mb: 4,
//                   }}
//                 >
//                   Enter Your Credentials To Continue
//                 </Typography>
//                 <TextField
//                   label="NTID"
//                   fullWidth
//                   margin="normal"
//                   value={ntid}
//                   onChange={(e) => setNtid(e.target.value)}
//                   InputProps={{
//                     startAdornment: (
//                       <InputAdornment position="start">
//                         <AccountCircleIcon />
//                       </InputAdornment>
//                     ),
//                   }}
//                 />
//                 <TextField
//                   label="Password"
//                   type="password"
//                   fullWidth
//                   margin="normal"
//                   value={password}
//                   onChange={(e) => setPassword(e.target.value)}
//                   InputProps={{
//                     startAdornment: (
//                       <InputAdornment position="start">
//                         <LockIcon />
//                       </InputAdornment>
//                     ),
//                   }}
//                 />
//                 {error && (
//                   <Typography color="error" variant="body2">
//                     {error}
//                   </Typography>
//                 )}
//                 <Button
//                   variant="contained"
//                   color="primary"
//                   fullWidth
//                   onClick={handleLoginSubmit}
//                   sx={{
//                     mt: 3,
//                     py: 1.5,
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     gap: '5px',
//                   }}
//                   disabled={isLoading}
//                 >
//                   {isLoading ? 'Logging in...' : (
//                     Array.from({ length: 3 }).map((_, i) => (
//                       <motion.div
//                         key={i}
//                         initial={{ opacity: 0, x: -10 }}
//                         animate={{ opacity: 1, x: 0 }}
//                         transition={{
//                           delay: i * 0.2,
//                           repeat: Infinity,
//                           repeatType: 'reverse',
//                           duration: 0.6,
//                         }}
//                       >
//                         <ArrowForwardIcon />
//                       </motion.div>
//                     ))
//                   )}
//                 </Button>
//               </>
//             )}
//             {showChannelSelection && (
//               <>
//                 <Typography
//                   variant="h6"
//                   sx={{
//                     color: '#A52A2A',
//                     fontWeight: 'bold',
//                     mb: 4,
//                   }}
//                 >
//                   Select Channel
//                 </Typography>
//                 <FormControl fullWidth margin="normal">
//                   <InputLabel>Channel</InputLabel>
//                   <Select
//                     value={selectedChannel}
//                     label="Channel"
//                     onChange={(e) => setSelectedChannel(e.target.value)}
//                     startAdornment={
//                       <InputAdornment position="start">
//                         <TvIcon />
//                       </InputAdornment>
//                     }
//                   >
//                     {channelData.map((channel, index) => (
//                       <MenuItem key={index} value={channel}>
//                         {channel}
//                       </MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>
//                 {error && (
//                   <Typography color="error" variant="body2">
//                     {error}
//                   </Typography>
//                 )}
//                 <Button
//                   variant="contained"
//                   color="primary"
//                   fullWidth
//                   onClick={handleChannelConfirm}
//                   sx={{
//                     mt: 3,
//                     py: 1.5,
//                   }}
//                 >
//                   Confirm Channel
//                 </Button>
//               </>
//             )}
//             {/* Logo Section */}
//             <Box
//               sx={{
//                 textAlign: 'center',
//                 mt: 4, // Space between the form and the logo
//               }}
//             >
//               <style>
//                 {`
//                   @keyframes blink {
//                     0% { opacity: 1; }
//                     50% { opacity: 0.7; }
//                     100% { opacity: 1; }
//                   }
//                   .blinking-image {
//                     animation: blink 1.5s infinite;
//                   }
//                 `}
//               </style>
//               <img
//                 src="/logo_liv.JPG" // Public folder path
//                 alt="LIVA Logo"
//                 className="blinking-image"
//                 style={{ width: '200px', height: 'auto' }} // Adjust size
//               />
//             </Box>
//           </CardContent>
//         </Card>
//       </motion.div>
//     </Container>
//   );
// }
// export default LoginPage;

// LoginPage.js

import React, { useState, useContext, useEffect } from 'react';
import {
  TextField,
  Button,
  Typography,
  Container,
  Box,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Card,
  CardContent,
  InputAdornment,
} from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LockIcon from '@mui/icons-material/Lock';
import TvIcon from '@mui/icons-material/Tv';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import JSEncrypt from 'jsencrypt';
import { toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
import { UserContext } from '../context/UserContext';
import { AuthContext } from '../context/AuthContext';
import { encryptAES, decryptAES } from './../utils/cryptoUtils';
import { updateUserIdSSO } from '../utils/apiClient3';
import { useLocation } from 'react-router-dom';
import { useSearchParams } from 'react-router-dom';
// import { setInMemoryNTID } from '../utils/apiClient'; // my new function for frontend
import apiClient from '../utils/apiClient';
//this is for only login of our app --> ntid and pass will be checked --> then they will again hit it to check in the data base for the ntid
import apiClient2 from '../utils/apiClient2';
import { jwtDecode } from 'jwt-decode';

import backgroundImage from '../pages/images/SM1085970.jpg';
import Logo from '../pages/images/iQuestLogo.png';

function LoginPage() {
  const [ntid, setNtid] = useState('');
  const [password, setPassword] = useState('');
  // const [selectedChannel, setSelectedChannel] = useState('');
  const selectedChannel = ' Proprietary';
  const [channelData, setChannelData] = useState([]);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [userError, setUserLoginError] = useState('')
  const { setUserNTID, setUserChannel, userNTID } = useContext(UserContext);
  const { setUser } = useContext(AuthContext);
  const PUBLIC_KEY = 'MIGeMA0GCSqGSIb3DQEBAQUAA4GMADCBiAKBgH5ZLNKluDikQ+Bjp80aiTvCHo5axT76N5GRyeE/rdU1I/OQmha+EKmvNAHxa6aGft5XwPOciqMaEdWrhJ+rPhScbkZFZdApGJtn717SKHv/vVrcvUW9JkMzBLJ9Xl/B0WM5PXFlLeof89UVC52r+Zq05C/DFUVBNjLxvZmdkCOtAgMBAAE='
  const location = useLocation()
  let navigate = useNavigate();
  //   useEffect(() => {
  //    const handlePopState = () => window.history.pushState(null, "", window.location.href);
  //    window.history.pushState(null, "", window.location.href);
  //    window.addEventListener("popstate", handlePopState);
  //    return () => window.removeEventListener("popstate", handlePopState);
  // }, []);


  // SSO FLOW START1
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const ssoKey = decodeURIComponent(window.location.search.split('?key=')[1]);            // already decoded by URLSearchParams
    // const ntid = window.location.search.split('?key=')[1].split('|')[0]            // already decoded by URLSearchParams
    const ntid = ssoKey.split('|')[0];
    
    if (!ssoKey) {
      // window.location.href = '/#/unauthorized'
    };
    (async () => {
      try {
        var axios = require('axios');
        var data = {
          "agentId": "IPRU75591"
        }

        // apiClient.post('biu-chatbot/generate_key', data)
        // .then(function (response) {
        //   console.log(JSON.stringify(response.data));
        // })
        // .catch(function (error) {
        //   console.log(error);
        // });
        // console.log("enc", encryptAES('IPRU75591'))
        // console.log("agent", encryptAES({ "agentId": "IPRU75591" }))

        // split encUserId|encKey from the URL
        // const [encUserId] = ssoKey.split('|');
        // decrypt ONLY the user id
        const userId = ntid;
        localStorage.clear()
        console.log("userid", userId)
        // store user id (needed by your app)
        localStorage.setItem('ntid', userId);
        localStorage.setItem('user_ntid', userId);
        // call SSO-JWT with: key (combined) + agentId (plain user id)
        const res = await updateUserIdSSO(ssoKey, userId);
        console.log(res)
        // store token if Apigee attached it
        // if (res['jwt-token']) {
        //   localStorage.setItem('session_token', res['jwt-token']);
        // }
        
        const token = res['jwt-token']
        localStorage.setItem("apg_jwt", res['jwt-token']);
        if (token.split(".").length === 3) {
          try {
            const decoded = jwtDecode(token);
            if (decoded?.exp) {
              localStorage.setItem("apg_jwt_expiry", decoded.exp * 1000);
            }
          } catch (err) {
            console.warn("JWT decode skipped (invalid/opaque token):", err);
          }
        } else {
          // Apigee opaque tokens, skip decode
          console.warn("Token is not a standard JWT, skipping decode:", token);
        }

        setUserNTID(userId);
        // navigate('/App2');
        navigate('/App2', { replace: true});

      } catch (e) {
        console.error('SSO login failedeee', e);
      } finally {
        // clean ?key= from URL
        // const cleanUrl = `${window.location.origin}${window.location.pathname}`;
        // window.history.replaceState({}, document.title, cleanUrl);
      }
    })();
  }, []);
  // SSO FLOW END1

  // Logger (imp)
  // What changes need to be done ant our end and what changes need to be done at Yash end. Latest code the jb production mai tb SSO is breaking.




  const encryptData = (data) => {
    const encryptor = new JSEncrypt();
    encryptor.setPublicKey(PUBLIC_KEY);
    return encryptor.encrypt(data);
  };
  const handleLoginSubmit = async () => {

    if (!ntid || !password) {
      setError('Please enter NTID and Password');
      return;
    }

    try {
      // setIsLoading(true);
      // const encryptedNTID = encryptData(ntid);
      // const encryptedPassword = encryptData(password);
      // const encryptedMetaData = encryptData(
      //   JSON.stringify({
      //     ntid: ntid,
      //     timestamp: Date.now(),
      //   })
      // );
      setIsLoading(true);
      console.log(ntid);
      setUserNTID(ntid);
      setUserLoginError('');

      const encryptedNTID = (ntid);
      const encryptedPassword = (password);
      const encryptedMetaData = (
        JSON.stringify({
          ntid: ntid,
          timestamp: Date.now(),
        })
      );
      // Call the const.jwt endpoint
      // const response = await axios.post('https://apignonprod.iciciprulife.com/v1/generate/ldap/encrypted/authentication', {
      const response = await apiClient2.post(process.env.REACT_APP_BASE_URL+'/v1/generate/ldap/encrypted/iquest/jwt', {
        "ntID": ntid,
        "password": password
      });
      console.log("resp....", response)
      
      // // Use mockResponse instead of actual response
      // const response = mockResponse;
      // if (response.data.Token) {
      //   toast.success("Authentication Successful!");
      //this is for apignonprod
      // if (response.data.Status=="Login Successful") {
      //this is for apidex
      if (response.data.success) {
        // Extract NTID from response.data.data if available
        let userInfo;
        // if (typeof response.data.data === 'string') {
        //   try {
        //     userInfo = JSON.parse(response.data.data);
        //   } catch {
        //     userInfo = { NTID: ntid };
        //   }
        // } else {
        //   userInfo = response.data.data || { NTID: ntid };
        // }
        // Store NTID in userContext for frontend usage
        setUserNTID(ntid);
        // 2) Also store it in memory for encryption usage
        // setInMemoryNTID(ntid);  
        // Now show the channel selection UI
        // setShowChannelSelection(true);
        setIsLoading(false);
        localStorage.setItem('user_ntid', ntid)
        setUser({ username: ntid, channel: selectedChannel });
        // navigate('/App2');
        navigate('/App2', { replace: true});

      } else {
        setUserLoginError('Incorrect username or/and password.')
        setError("Authentication Failed!");
      }
    } catch (error) {
      console.error("Error:", error);
      setUserLoginError('Incorrect username or/and password.')

      setError(
        error.response?.data?.message || "Something went wrong. Please try again."
      );
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <Box
      sx={{
        height: '100vh',
        width: '100vw',
        display: 'none',
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      {/* Background with the left side content */}
      <Box
        sx={{
          width: '110%',
          height: '110%',
          position: 'absolute',
          top: 0,
          left: 0,
          backgroundImage: `linear-gradient(rgba(255, 239, 213, 0.7), rgba(255, 239, 213, 0.7)), url(${backgroundImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          zIndex: 0,
        }}
      >
        {/* Text overlay */}
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '12%',
            transform: 'translateY(-50%)',
            zIndex: 1,
            textAlign: 'left',
          }}
        >
          <Typography
            variant="h1"
            sx={{
              color: '#002f6c',
              fontWeight: 'bold',
              fontSize: '4.5rem',
              lineHeight: 1.2,
              fontFamily: 'Mulish-Bold, sans-serif',
            }}
          >
            Understanding needs.
          </Typography>
          <Typography
            variant="h1"
            sx={{
              color: '#002f6c',
              fontWeight: 'bold',
              fontSize: '3.5rem',
              lineHeight: 1.2,
              fontFamily: 'Mulish-Bold, sans-serif',
            }}
          >
            Delivering value.
          </Typography>
        </Box>
      </Box>
      {/* Login Box */}
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          right: '15%',
          transform: 'translateY(-50%)',
          width: '380px',
          zIndex: 2,
        }}
      >
        {/* Login Card */}
        <Card
          sx={{
            borderRadius: '15px',
            boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
            backgroundColor: 'white',
            padding: '24px 20px',
            width: '100%',
          }}
        >
          <CardContent
            sx={{
              padding: '8px 10px',
              '&:last-child': { paddingBottom: '20px' },
            }}
          >
            {/* Logo */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginBottom: '20px',
              }}
            >
              <img
                // src="/logo_liv.JPG" // Adjust path as needed
                src={Logo}
                alt="LIVA Logo"
                style={{
                  height: '66px',
                  marginRight: '0px',
                  padding: '20px'
                }}
              />
              {/* <Typography
              sx={{
                color: '#C00026',
                fontSize: '22px',
                fontWeight: 'bold',
                fontFamily: 'Mulish-Bold, sans-serif',
              }}
            >
              LIVA
            </Typography> */}
            </Box>
            <>
              {/* Login Form */}
              {/* <Typography
                sx={{
                  color: '#333',
                  fontSize: '16px',
                  marginBottom: '24px',
                  fontFamily: 'Mulish-Regular, sans-serif',
                }}
              >
                {error ? (
                  <span style={{ color: 'red' }}>{error}</span>
                ) : (
                  "Sign in to continue"
                )}
              </Typography> */}
              Version 1.2
              <TextField
                placeholder="NTID"
                fullWidth
                value={ntid}
                onChange={(e) => setNtid(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <AccountCircleIcon sx={{ color: '#757575' }} />
                    </InputAdornment>
                  ),
                }}
                variant="outlined"
                size="small"
                sx={{
                  mb: 2,
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '30px',
                    backgroundColor: '#f5f5f5',
                  },
                  '& .MuiOutlinedInput-notchedOutline': {
                    border: 'none',
                  },
                }}
              />
              <TextField
                placeholder="Password"
                type="password"
                fullWidth
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <LockIcon sx={{ color: '#757575' }} />
                    </InputAdornment>
                  ),
                }}
                variant="outlined"
                size="small"
                sx={{
                  mb: 1,
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '30px',
                    backgroundColor: '#f5f5f5',
                  },
                  '& .MuiOutlinedInput-notchedOutline': {
                    border: 'none',
                  },
                }}
              />
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  mb: 2,
                }}
              >
                {/* <Link
                  component="button"
                  variant="body2"
                  underline="hover"
                  onClick={() => {
                    // Forgot password handler
                    console.log('Forgot password clicked');
                  }}
                  sx={{
                    color: '#757575',
                    fontSize: '12px',
                    fontFamily: 'Mulish-Regular, sans-serif',
                  }}
                >
                  Forgot password?
                </Link> */}
              </Box>
              <center><b style={{ color: 'red' }}>{userError}</b></center>
              <br />
              Version 1.2
              <Button
                variant="contained"
                fullWidth
                onClick={handleLoginSubmit}
                disabled={isLoading}
                sx={{
                  padding: '10px',
                  borderRadius: '30px',
                  backgroundColor: '#FF9800',
                  color: 'white',
                  textTransform: 'none',
                  fontFamily: 'Mulish-Bold, sans-serif',
                  fontSize: '18px',
                  boxShadow: 'none',
                  '&:hover': {
                    backgroundColor: '#F57C00',
                    boxShadow: 'none',
                  },
                }}
              >
                {isLoading ? 'Please wait...' : 'Get Started'}
              </Button>
            </>

          </CardContent>
        </Card>
      </Box>
    </Box>
  );

}
export default LoginPage;